// src/lib/qtyBox.js
// #708, Session 79.22b.4.3 -- THE BOX HOLDING A COUNT SOMEBODY CONFIRMS.
//
// Colby, watching Owen's load sheet: "the quantity box on the modal needs to
// stand out more. your eyes arent drawn there to confirm a count." It was the
// faintest thing on the sheet -- a pale grey hairline and a grey placeholder --
// while the name beside it was bold and dark, and Send takes the placeholder as
// the answer when nobody types. So the number a person is there to check was
// the one thing on the screen their eye skipped.
//
// APPROVED AS DRAWN at 79.22b.4.3 (the before/after drawing, R3), and extended
// by his instruction to "all the sheets that need it": a 2px Inventory-green
// edge, a pale green fill, a 22px number in the ramp's dark green, 48px tall --
// the commit floor, because this is the box a driver hits one-handed at a rack
// -- and, where a sheet has no label of its own, a small one above it naming
// what the number is. ONE style, so the boxes cannot drift apart again.
//
// The placeholder keeps the same dark green (index.css, `.qty-box`): the
// suggested count IS what gets sent when nobody types, so it must read as the
// answer, not as an empty box. #0F6E56 on #E1F5EE measures above 4.5.
//
// WHERE IT DOES NOT GO, and why, so nobody "finishes the sweep": Use stock,
// Receive and Adjust already draw a 22px bold number between - and + with a
// label above; order entry, prices, costs, reorder points, settings and label
// counts are form fields rather than counts being confirmed; the Tools pages are
// outside the August window.
export const QTY_BOX_CLASS = 'qty-box';

export const QTY_GREEN = {
  edge: '#1D9E75',   // Inventory, the locked domain colour
  fill: '#E1F5EE',
  ink: '#085041',
  label: '#0F6E56',
};

export function qtyBox({ width = 104, height = 48, align = 'right' } = {}) {
  return {
    width, minHeight: height, boxSizing: 'border-box',
    padding: align === 'center' ? '0 6px' : '0 12px',
    border: `2px solid ${QTY_GREEN.edge}`, borderRadius: 8,
    background: QTY_GREEN.fill, color: QTY_GREEN.ink,
    fontSize: 22, fontWeight: 600, textAlign: align,
  };
}

export const QTY_LABEL = {
  fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase',
  color: QTY_GREEN.label, marginBottom: 3,
};
